module.exports = __webpack_public_path__ + "static/img/home-login.4eaf364d.png";